import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PayScheduleBase } from '@xemplo/gp-types';
import {
  BodySmallRegular,
  BodyStandardMedium,
  BodyStandardSemiBold,
  BodyXSmallRegular,
  Colour,
  LinkUnderline,
  TextEllipsis,
} from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${BodySmallRegular};
`;

export const Label = styled.div`
  color: ${Colour.Gray[800]};
  ${BodyStandardSemiBold}
`;

export const Type = styled.div`
  color: ${Colour.Gray[400]};
`;

export const TypeContent = styled.div`
  color: ${Colour.Gray[700]};
  ${BodyStandardMedium}
`;

export const PayScheduleTable = styled(XemploTable<PayScheduleBase>)`
  ${BodyXSmallRegular};
  border-radius: 8px;
  border: 1px solid var(--black-black-10, rgba(0, 0, 0, 0.1));
  table {
    min-width: auto;
  }
`;

export const ViewPayScheduleNav = styled(Link)`
  cursor: pointer;
  ${BodyXSmallRegular}
  ${TextEllipsis}
  ${LinkUnderline}
  margin-left: 3px;
`;

export const PromptMessage = styled.div`
  color: ${Colour.Gray[600]};
  text-align: center;
`;
export const PromptBold = styled.b`
  color: ${Colour.Gray[600]};
  text-align: center;
`;
